import { Breadcrumb } from 'rsuite';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@monorepo/shared';
import { selectHaCurrentGroup } from '@monorepo/shared/store/groupSlice';

export const SubHeader = () => {
  const { groupId, accountId, regionId, instanceId, haId } = useParams();
  const { pathname } = useLocation();
  const [navs, setNavs] = useState<Record<string, any>[]>([]);
  const navigate = useNavigate();
  const currentHaGroup = useAppSelector(selectHaCurrentGroup);
  useEffect(() => {
    const arr = [];
    let baseLink = groupId ? '/group/accounts' : '/organization';
    if (groupId) {
      let id = groupId;
      if (currentHaGroup?.id && groupId !== currentHaGroup?.id) {
        id = currentHaGroup?.id;
      }
      baseLink = `${baseLink}/${id}`;
      arr.push({
        text: `Group: ${id}`,
        link: baseLink
      });
    }
    if (accountId) {
      baseLink = `${baseLink}/${accountId}`;
      arr.push({
        text: `Account: ${accountId}`,
        link: baseLink
      });
    }
    if (regionId && !pathname.includes('provision')) {
      baseLink = `${baseLink}/region/${regionId}`;
      arr.push({
        text: `Region: ${regionId}`,
        link: baseLink
      });
    }
    if (haId) {
      baseLink = `${baseLink}/ha/${haId}`;
      arr.push({
        text: `Cluster: ${haId}`,
        link: baseLink
      });
    }
    if (instanceId) {
      baseLink = `${baseLink}/instance/${instanceId}`;
      arr.push({
        text: `Instance: ${instanceId}`,
        link: baseLink
      });
    }
    if (pathname.includes('provision')) {
      arr.push({
        text: 'Provision Service'
      });
    }
    if (pathname.includes('ha/create')) {
      arr.push({
        text: 'Cluster Create'
      });
    }
    if (pathname.includes('upgrade')) {
      arr.push({
        text: 'Version Upgrade'
      });
    }
    if (pathname.includes('resize')) {
      arr.push({
        text: 'Resize'
      });
    }
    if (pathname.includes('ticket')) {
      arr.push({
        text: 'Create Upgrade Request'
      });
    }
    setNavs(arr);
  }, [accountId, regionId, pathname, currentHaGroup]);
  const goToNav = (i: number) => {
    if (i < 0) {
      navigate(i);
    }
  };
  return (
    <div className="subheader">
      <Breadcrumb>
        {navs?.map((nav: Record<string, any>, index: number) => (
          <Breadcrumb.Item
            as={() => (
              <span
                key={index}
                className="rs-breadcrumb-item"
                style={{ cursor: 'pointer' }}
                // onClick={() => goToNav(index - navs?.length + 1)}
              >
                <Link
                  // to={
                  //   nav.depth
                  //     ? ['..']
                  //         .flatMap((i) =>
                  //           Array.from({ length: nav.depth }).fill(i)
                  //         )
                  //         .join('/')
                  //     : '../..'
                  // }
                  to={nav.link}
                  // relative="path"
                  style={{ color: 'white' }}
                >
                  {nav.text}
                </Link>
              </span>
            )}
            active={index === navs.length - 1}
            key={index}
          >
            {nav.text}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </div>
  );
};
